import { jsx as _jsx } from "react/jsx-runtime";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
export const ItemDetailCarousel = ({ hasImages, validImages, imageBaseUrl, imageCarouselSettings, handleImageError, classes, }) => {
    if (!hasImages)
        return null;
    return (_jsx("div", Object.assign({ role: "region", "aria-label": "Product images carousel" }, { children: _jsx(Carousel, Object.assign({}, imageCarouselSettings, { children: validImages.map((image, index) => (_jsx("img", { className: classes.sliderImage, src: imageBaseUrl ? `${imageBaseUrl}${image}` : image, onError: handleImageError, alt: `Product image ${index + 1}`, loading: index === 0 ? "eager" : "lazy" }, image))) })) })));
};
